import React, { useEffect, useState } from "react";
import "./css/FAQ.css"; // Dedicated styling file

// Import your standard page shell components
import Navbar from "./components/Navbar";
import Newsletter from "./components/NewsLetter";
import Footer from "./components/Footer";
import { FaChevronDown, FaQuestionCircle, FaHeadset } from "react-icons/fa";

function FAQ() {
    // Automatically scroll to top when visiting the FAQ page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // State to track open/closed accordion items (allows multiple or single toggle)
    const [activeIndex, setActiveIndex] = useState(0); // Default first item open

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    // Comprehensive FAQ list tailored for Fixovera Pvt limited, covering services, bookings, payments, and support
    const faqData = [
        {
            question: "What is Fixovera?",
            answer: "Fixovera is a digital home services marketplace that connects customers with service professionals for everyday home maintenance, repair, cleaning, and improvement needs. Customers can discover and book services through the Fixovera platform."
        },
        {
            question: "What services are available on Fixovera?",
            answer: "Fixovera offers a wide range of home services including Home Cleaning, Plumbing, Electrical Services, AC & Appliance Services, Painting & Home Renovation, Carpentry, and Pest Control."
        },
        {
            question: "How do I book a service through Fixovera?",
            answer: "You can book a service by selecting the required service category, providing your service details and preferred schedule, and submitting your booking request through the Fixovera platform. A suitable service professional can then be assigned to handle your request."
        },
        {
            question: "Can I choose a service professional?",
            answer: "Fixovera is designed to connect customers with suitable service professionals based on the requested service and availability. Depending on the booking flow and service category, available professional details may be provided before or during the booking process."
        },
        {
            question: "How can I track my service booking?",
            answer: "You can track your booking through your Fixovera account. Booking information may include the requested service, booking status, scheduled time, service professional details, and other relevant updates."
        },
        {
            question: "Are payments made securely?",
            answer: "Yes. Fixovera is designed to provide a secure payment experience using trusted payment processing systems. Customers should always complete payments through the official Fixovera platform and avoid sharing sensitive payment information directly with service professionals."
        },
        {
            question: "What happens if I need to cancel or reschedule a booking?",
            answer: "Cancellation and rescheduling are subject to the applicable Fixovera booking and service policies. Customers should review the relevant cancellation terms and submit cancellation or rescheduling requests through the platform as early as possible."
        },
        {
            question: "How can I become a Fixovera service partner?",
            answer: "Service professionals interested in joining the Fixovera network can register as a service partner through the available partner onboarding process. Applicants may be required to provide personal, professional, identification, and service-related information for verification."
        },
        {
            question: "How does Fixovera maintain service quality?",
            answer: "Fixovera focuses on building a trusted service ecosystem by supporting professional onboarding, service management, customer feedback, transparent booking processes, and continuous improvement of the overall customer experience."
        },
        {
            question: "How can I contact Fixovera support?",
            answer: "For questions, booking assistance, technical issues, or other service-related concerns, you can contact the Fixovera support team through the official contact channels provided on the Fixovera website or platform."
        }
    ];

    return (

        <div className="page-wrapper">{/* Site Navigation Bar */}
            <Navbar />
            {/* Main Content Area */}
            <div className="faq-page">
                <div className="container py-5">
                    <div className="row justify-content-center">


                        <div className="col-lg-10">

                            {/* Page Header */}
                            <div className="faq-header text-center mb-5">

                                <div className="faq-icon-wrapper mb-3">
                                    <FaQuestionCircle className="faq-main-icon" />
                                </div>

                                <h1 className="faq-title">
                                    Frequently Asked Questions
                                </h1>

                                <p className="faq-subtitle">
                                    Fixovera — Everything you need to know about our home services
                                </p>

                            </div>


                            {/* FAQ Content Card / Accordion Container */}
                            <div className="faq-card p-4 p-md-5 shadow-sm">

                                <p className="lead-text mb-4">
                                    Find answers to common questions about Fixovera, our home
                                    services, bookings, service professionals, payments, and
                                    customer support. If you cannot find the information you are
                                    looking for, our support team is here to help.
                                </p>


                                {/* FAQ Accordion */}
                                <div className="accordion-list">

                                    {faqData.map((item, index) => {

                                        const isOpen = activeIndex === index;

                                        return (

                                            <div
                                                key={index}
                                                className={`faq-accordion-item ${isOpen ? "active" : ""
                                                    }`}
                                            >

                                                <button
                                                    className="faq-question-btn"
                                                    onClick={() =>
                                                        toggleAccordion(index)
                                                    }
                                                    aria-expanded={isOpen}
                                                >

                                                    <span className="faq-q-number">
                                                        {String(index + 1).padStart(2, "0")}.
                                                    </span>

                                                    <span className="faq-q-text">
                                                        {item.question}
                                                    </span>

                                                    <FaChevronDown
                                                        className={`faq-chevron ${isOpen ? "rotate" : ""
                                                            }`}
                                                    />

                                                </button>


                                                <div
                                                    className={`faq-answer-collapse ${isOpen ? "show" : ""
                                                        }`}
                                                >

                                                    <div className="faq-answer-body">

                                                        <p>
                                                            {item.answer}
                                                        </p>

                                                    </div>

                                                </div>

                                            </div>

                                        );

                                    })}

                                </div>


                                <hr className="section-divider my-5" />


                                {/* Help Box Banner */}
                                <div className="faq-help-box text-center p-4">

                                    <FaHeadset className="faq-help-icon mb-2" />

                                    <h4>
                                        Need Help With Your Booking?
                                    </h4>

                                    <p>
                                        Have a question about a service, booking, payment, or
                                        service professional? Our team is here to assist you.
                                    </p>

                                    <a
                                        href="mailto:info@fixovera.com"
                                        className="faq-support-btn"
                                    >
                                        Contact Fixovera Support
                                    </a>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* Global Newsletter Section */}
            <Newsletter />

            {/* Global Footer Component */}
            <Footer />
        </div>
    );
}

export default FAQ;